<ng-container *ngIf="title">
  <app-section-header *ngIf="!isSubTitle" [title]="title" [tooltip]="titleHint" [required]="required"></app-section-header>
  <div class="bold bottom-spacer-half" *ngIf="isSubTitle">
    {{ title | translate }}
    <small class="text-muted medium" *ngIf="titleHint">
      {{ titleHint | translate }}
      <span class="text-warning" *ngIf="required">*</span>
    </small>
    <span class="text-warning normal" *ngIf="!titleHint && required">*</span>
  </div>
</ng-container>
<div class="flex">
  <div class="image-block" *ngIf="!disabled && !isLoading && (!anyImageLoaded || isSaving)" [ngClass]="{'uploader-error': requiredButEmpty}">
    <ng-container *ngIf="!isSaving">
      <div class="flex flex-middle">
        <app-link [link]="button" (linkClicked)="openUploader()" [icon]="'plus'"></app-link>
      </div>
      <small class="text-muted">{{ hint | translate }}</small>
    </ng-container>
    <app-loader class="top-spacer bottom-spacer" [loading]="isSaving" [size]="16"></app-loader>
  </div>

  <app-s3-downloader *ngIf="!isSaving && model"
    [model]="model" [ratio]="ratio"
    [type]="type" [ownerCentreId]="ownerCentreId" [ownerId]="id"
    (loadingChange)="delayedLoaderUpdate($event)"
    (imageLoaded)="loadedImage[ratio] = $event"
    [badge]="multipleRatios" [inline]="multipleRatios"
    [slim]="true"
  ></app-s3-downloader>

  <ng-container *ngIf="model && multipleRatios && !isSaving">
    <app-s3-downloader
      [model]="model" [ratio]="S3UploaderRatios.Retro"
      [type]="type" [ownerCentreId]="ownerCentreId" [ownerId]="id"
      [badge]="true" [inline]="true"
      [slim]="true"
      (loadingChange)="delayedLoaderUpdate($event)"
      (imageLoaded)="loadedImage[S3UploaderRatios.Retro] = $event"
    ></app-s3-downloader>
    <app-s3-downloader
      [model]="model" [ratio]="S3UploaderRatios.Square"
      [type]="type" [ownerCentreId]="ownerCentreId" [ownerId]="id"
      [badge]="true" [inline]="true"
      [slim]="true"
      (loadingChange)="delayedLoaderUpdate($event)"
      (imageLoaded)="loadedImage[S3UploaderRatios.Square] = $event"
    ></app-s3-downloader>
  </ng-container>
</div>

<ng-container *ngIf="!disabled && !isSaving && allImagesLoaded">
  <hr class="slim">
  <div class="controls top-spacer">
    <button mat-button class="input-button" [ngClass]="{'icon-button': utilService.isMobile}" (click)="resizeImage()">
      <mat-icon class="svg-icon" [svgIcon]="'crop'"></mat-icon>
      <span *ngIf="!utilService.isMobile">{{ 'general.api_uploader_crop' | translate }}</span>
    </button>
    <button mat-button class="left-spacer input-button" [ngClass]="{'icon-button': utilService.isMobile}" (click)="openUploader()">
      <mat-icon class="svg-icon" [svgIcon]="'upload'"></mat-icon>
      <span *ngIf="!utilService.isMobile">{{ 'general.api_uploader_upload' | translate }}</span>
    </button>
    <button mat-button class="left-spacer input-button" [ngClass]="{'icon-button': utilService.isMobile}" (click)="removeImage()" *ngIf="canDelete">
      <mat-icon class="svg-icon" [svgIcon]="'trash'"></mat-icon>
      <span *ngIf="!utilService.isMobile">{{ 'general.api_uploader_delete' | translate }}</span>
    </button>
  </div>
</ng-container>

<input type="file" [accept]="acceptedMimeTypes" [multiple]="false" (change)="processFile($event)" #uploader class="hide display-none">
